import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FONTS } from 'utils/styles/fonts';
import { deviceMax } from 'utils/styles/breakpoints';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const Container = styled.div`
  width: 100%;
  height: 45px;
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}

  .passportInput {
    width: 575px;
  }

  .iconButton {
    width: 21px;
    height: 17px;

    @media ${deviceMax.laptopM} {
      width: 17px;
      height: 14px;
    }

    @media ${deviceMax.mobileS} {
      width: 13px;
      height: 9px;
    }
  }
  
  input {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-left: 5px;
    background: transparent;
    color: ${COLORS.darkGray};

    @media ${deviceMax.laptopM} {
      ${FONTS.font16}
    }

    @media ${deviceMax.tablet} {
      ${FONTS.font24}
    }

    @media ${deviceMax.mobileS} {
      ${FONTS.font12}
    }
  }
`;
